<div
  id="uzd-pregnancy"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12 clr-col-md-6">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="p_date" />
      </div>
      <div class="clr-col-sm-12 clr-col-md-6">
        <clr-select-container [class.clr-float-md-right]="true">
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="p_type">
            <option value="трансабдомінально">трансабдомінально</option>
            <option value="трансвагінально">трансвагінально</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Перший день ОМ:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_first_day_om" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Термін пологів:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_termin_pologiv" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="p_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('дворога', 'p_matka')"> дворога </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('сідловидна', 'p_matka')">сідловидна</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Матка:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_matka"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Положення:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="p_polozennya">
            <option value="anteflexio">Retroflexio</option>
            <option value="retroflexio">Anteflexio</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-2">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розміри тіла матки:</label>
        </clr-input-container>
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">довжина:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="p_dovzyna" />
        </clr-input-container> мм,
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">товщина:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="p_tovshuna" />
        </clr-input-container> мм,
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ширина:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="p_shuruna" />
        </clr-input-container> мм.
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">V = </label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="p_v" />
        </clr-input-container> см <span class="step">3</span>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('однорідна', 'p_exostructure')"> однорідна </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('неоднорідна', 'p_exostructure')">неоднорідна</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ехоструктура</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_exostructure"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('візуалізується до мм', 'p_plivne')"> візуалізується до мм </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не візуалізується', 'p_plivne')">не візуалізується</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">В порожнині матки плідне яйце:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_plivne"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('візуалізується до мм', 'p_ktr')"> візуалізується до мм </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не візуалізується', 'p_ktr')">не візуалізується</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Куприко-тім'яний розмір (КТР):</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_ktr"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('+', 'p_sertse')"> + </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('-', 'p_sertse')"> - </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ритмічне', 'p_sertse')"> ритмічне </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('аритмічне', 'p_sertse')"> аритмічне </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серцебиття:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_sertse"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('+', 'p_zhovtochnyy_mishok')"> + </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('-', 'p_zhovtochnyy_mishok')"> - </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Жовточний мішок:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_zhovtochnyy_mishok"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не визначаються', 'p_dilyanku')"> не визначаються </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('визначаються', 'p_dilyanku')"> визначаються </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ділянки відшарування плідного яйця:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_dilyanku"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не підвищений', 'p_tonus')"> не підвищений </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('підвищений', 'p_tonus')"> підвищений </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('по передній стінці', 'p_tonus')"> по передній стінці </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('по задній стінці', 'p_tonus')"> по задній стінці </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Тонус міометрію:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_tonus"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Шийка матки:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_shuyka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">вн.вічко:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_vichko" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Правий ЯЄЧНИК ехоструктура:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_p_yaye_exostructure" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Лівий ЯЄЧНИК ехоструктура:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_l_yaye_exostructure" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рідина в дугласовому просторі:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_riduna_v_duglas" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">По гастації:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="p_po_gastatsii" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('Вагітність', 'p_zakluchennya')"> Вагітність </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('прогресує', 'p_zakluchennya')"> прогресує </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не прогресує', 'p_zakluchennya')">не прогресує </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('завмерла', 'p_zakluchennya')">завмерла </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЗАКЛЮЧЕННЯ:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="p_zakluchennya"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
